import { useEffect, useState } from "react";
import ContentLoader from "../../utils/ContentLoader";
import { DatePicker, Modal, Tabs } from "antd";
import ImagePreviewModal from "../../utils/ImagePreviewModal";
import Select from "react-select";
import { API } from "../../config/constants";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { mapEventTypeOptions } from "../../utils/eventTypeUtils";
import { api } from "../../utils/apiClient";
import { Icon } from "@iconify/react/dist/iconify.js";
import { customSelectStyles } from "../../utils/customizedStyles";

const { confirm } = Modal;

const statusOptions = [
  { value: "new", label: "New" },
  { value: "accepted", label: "Accepted" },
  { value: "rejected", label: "Rejected" },
];

const recurringOptions = [
  { value: 1, label: "Yes" },
  { value: 0, label: "No" },
];

const recurrenceTypeOptions = [
  { value: "monthly", label: "Monthly" },
  { value: "weekly", label: "Weekly" },
];

const monthlyWeekOptions = [
  { value: "first", label: "First" },
  { value: "second", label: "Second" },
  { value: "third", label: "Third" },
  { value: "fourth", label: "Fourth" },
  { value: "last", label: "Last" },
];

const weeklyDayOptions = [
  { value: "monday", label: "Monday" },
  { value: "tuesday", label: "Tuesday" },
  { value: "wednesday", label: "Wednesday" },
  { value: "thursday", label: "Thursday" },
  { value: "friday", label: "Friday" },
  { value: "saturday", label: "Saturday" },
  { value: "sunday", label: "Sunday" },
];

export default function EventForm({
  onSubmit,
  onCancel,
  initialData = {},
  eventTitleOptions = [],
  eventDioceseOptions = [],
  eventParisOptions = [],
  fetchParishes,
  fcmToken,
}) {
  const isEdit = Boolean(initialData?.id);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [eventOptions, setEventOptions] = useState(eventTitleOptions);
  const [isAccepted, setIsAccepted] = useState(false);

  useEffect(() => {
    if (!eventTitleOptions?.length) return;
    setEventOptions(mapEventTypeOptions(eventTitleOptions));
  }, [eventTitleOptions]);

  const [formData, setFormData] = useState({
    church_name: {
      tn: "",
      en: "",
    },

    place: {
      tn: "",
      en: "",
    },

    event_title: {
      tn: "",
      en: "",
    },

    details: {
      tn: "",
      en: "",
    },

    event_type_id: "",
    event_type_others: "",

    status: "new",

    parish_id: "",

    is_recurring: 0,
    recurring_type: "",
    recurring_pattern: "",
    monthly_week: "",
    weekly_day: "",

    church_photo: null,
    previewImage: null,

    start_datetime: null,
    end_datetime: null,

    isSameAsParish: false,

    latitude: "",
    longitude: "",

    views: 0,
    share: 0,
  });

  console.log("data===>", initialData)

  // =========================
  // AUTO DATE
  // =========================

  useEffect(() => {
    if (!initialData || !initialData.id) {
      const now = dayjs();

      setFormData((prev) => ({
        ...prev,
        start_datetime: now,
        end_datetime: now.add(1, "hour"),
      }));
    }
  }, [initialData]);

  // =========================
  // EDIT PREFILL
  // =========================

  useEffect(() => {
    if (initialData && initialData.id) {
      const dioceseId = initialData.parish?.diocese?.id;
      const parishId = initialData.parish?.id;

      let monthly_week = "";
      let weekly_day = "";

      if (
        initialData.is_recurring &&
        initialData.recurring_type === "monthly" &&
        initialData.recurring_pattern
      ) {
        const parts = initialData.recurring_pattern.split("_");
        monthly_week = parts[0] || "";
        weekly_day = parts[1] || "";
      }

      setFormData((prev) => ({
        ...prev,

        church_name: {
          tn: initialData.church?.name?.tn || "",
          en: initialData.church?.name?.en || "",
        },
        place: {
          tn: initialData.church?.place?.tn || "",
          en: initialData.church?.place?.en || "",
        },
        event_title: {
          tn: initialData?.event_title?.tn || "",
          en: initialData?.event_title?.en || "",
        },
        details: {
          tn: initialData?.details?.tn || "",
          en: initialData?.details?.en || "",
        },

        event_type_id: initialData?.event_type_id ? initialData.event_type_id : "others",
        event_type_others: initialData?.event_type_id ? "" : (initialData?.event_type_others ?? ""),
        status: initialData.status || "new",
        parish_id: parishId ? Number(parishId) : "",
        diocese_id: dioceseId ? Number(dioceseId) : "",
        is_recurring: initialData.is_recurring ? 1 : 0,
        recurring_type: initialData.recurring_type || "",
        recurring_pattern: initialData.recurring_pattern || "",
        monthly_week: monthly_week,   // <-- use split value
        weekly_day: weekly_day,       // <-- use split value
        church_photo: null, // file only
        previewImage: initialData.church_photo ? `${API.IMAGE_BASE_URL}/${initialData.church_photo}` : null,
        start_datetime: initialData.start_datetime ? dayjs(initialData.start_datetime) : null,
        end_datetime: initialData.end_datetime ? dayjs(initialData.end_datetime) : null,
        latitude: initialData.church?.latitude || initialData.parish?.latitude || "",
        longitude: initialData.church?.longitude || initialData.parish?.longitude || "",
        // details: initialData.details || "",
        views: initialData.views,
        share: initialData.share
      }));

      if (initialData.status === "accepted") {
        setIsAccepted(true);
      }

      if (dioceseId) {
        fetchParishes(dioceseId); // load parish options for this diocese
      }
    }
  }, [initialData]);

  // =========================
  // NORMAL CHANGE
  // =========================

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file" && files[0]) {
      const file = files[0];

      const previewURL = URL.createObjectURL(file);

      setFormData((prev) => ({
        ...prev,
        [name]: file,
        previewImage: previewURL,
      }));

      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));

      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  // =========================
  // MULTILINGUAL CHANGE
  // =========================

  const handleLangFieldChange = (field, lang, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: {
        ...prev[field],
        [lang]: value,
      },
    }));

    setErrors((prev) => ({
      ...prev,
      [`${field}_${lang}`]: "",
    }));
  };

  // =========================
  // UPDATE FIELD
  // =========================

  const updateField = (field, value) => {
    setFormData((prev) => {
      let updatedData = {
        ...prev,
        [field]: value,
      };

      if (field === "is_recurring" && value === 0) {
        updatedData = {
          ...updatedData,
          recurring_type: "",
          recurring_pattern: "",
          monthly_week: "",
          weekly_day: "",
        };
      }

      return updatedData;
    });

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  // =========================
  // VALIDATION
  // =========================

  const validate = () => {
    const newErrors = {};

    const tamilFilled =
      formData.church_name.tn?.trim() &&
      formData.place.tn?.trim() &&
      formData.event_title.tn?.trim();

    const englishFilled =
      formData.church_name.en?.trim() &&
      formData.place.en?.trim() &&
      formData.event_title.en?.trim();

    if (!tamilFilled && !englishFilled) {
      // Highlight Tamil fields
      if (!formData.church_name.tn?.trim())
        newErrors.church_name_tn = true;

      if (!formData.place.tn?.trim())
        newErrors.place_tn = true;

      if (!formData.event_title.tn?.trim())
        newErrors.event_title_tn = true;

      // Highlight English fields
      if (!formData.church_name.en?.trim())
        newErrors.church_name_en = true;

      if (!formData.place.en?.trim())
        newErrors.place_en = true;

      if (!formData.event_title.en?.trim())
        newErrors.event_title_en = true;

      // toast.error("Please complete either the Tamil tab or the English tab.");
    }

    if (formData.event_type_id === "others") {
      if (!formData.event_type_others?.trim()) {
        newErrors.event_type_others = true;
      }
    } else if (!formData.event_type_id) {
      newErrors.event_type_id = true;
    }

    if (!formData.start_datetime) {
      newErrors.start_datetime = true;
    }

    if (!formData.end_datetime) {
      newErrors.end_datetime = true;
    }

    if (
      formData.start_datetime &&
      formData.end_datetime &&
      dayjs(formData.end_datetime).isBefore(
        dayjs(formData.start_datetime)
      )
    ) {
      newErrors.end_datetime = true;

      toast.error("End date must be greater than start date");
    }

    if (formData.is_recurring === 1) {
      if (!formData.recurring_type) return false;

      if (
        formData.recurring_type === "monthly" &&
        (!formData.monthly_week || !formData.weekly_day)
      ) {
        return false;
      }

      if (
        formData.recurring_type === "weekly" &&
        !formData.weekly_day
      ) {
        return false;
      }
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // =========================
  // SUBMIT
  // =========================

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      toast.error("Please fill all required fields before submit.")
      return;
    }

    const fd = new FormData();

    // =========================
    // MULTILINGUAL JSON FIELDS
    // =========================

    fd.append("church_name", JSON.stringify(formData.church_name));

    fd.append("place", JSON.stringify(formData.place));

    fd.append("event_title", JSON.stringify(formData.event_title));

    fd.append("details", JSON.stringify(formData.details));

    // =========================
    // NORMAL FIELDS
    // =========================

    fd.append("status", formData.status);

    fd.append("is_recurring", formData.is_recurring);

    fd.append("recurring_type", formData.recurring_type);

    fd.append("recurring_pattern", formData.recurring_pattern);

    fd.append("parish_id", formData.parish_id);

    fd.append(
      "isSameAsParish",
      formData.isSameAsParish ? 1 : 0
    );

    fd.append("latitude", formData.latitude || "");

    fd.append("longitude", formData.longitude || "");

    fd.append("views", formData.views);

    fd.append("share", formData.share);

    if (formData.event_type_id === "others") {
      fd.append("event_type_id", "");

      fd.append(
        "event_type_others",
        formData.event_type_others
      );
    } else {
      fd.append("event_type_id", formData.event_type_id);
    }

    if (formData.start_datetime) {
      fd.append(
        "start_datetime",
        formData.start_datetime.toISOString()
      );
    }

    if (formData.end_datetime) {
      fd.append(
        "end_datetime",
        formData.end_datetime.toISOString()
      );
    }

    if (formData.church_photo) {
      fd.append("church_photo", formData.church_photo);
    }

    try {
      await onSubmit(fd);

      if (isAccepted === true) return;

      if (formData.status === "accepted") {
        await sendFcmNotification(
          fcmToken,
          "நிகழ்வு வெளியிடப்பட்டது",
          `வாழ்த்துக்கள் உங்கள் நிகழ்வு "${formData.event_title.ta}"`
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const sendFcmNotification = async (
    fcmToken,
    title,
    body
  ) => {
    return await api.post("/test-fcm", {
      token: fcmToken,
      title,
      body,
    });
  };

  if (loading) return <ContentLoader />;

  return (
    <div className="col-lg-12">
      <div className="card mt-3">
        <div className="card-header">
          <h5 className="card-title mb-0">
            {isEdit ? "Edit Event" : "Create Event"}
          </h5>
        </div>

        <div className="card-body">
          <form
            className="row gy-3"
            onSubmit={handleSubmit}
            noValidate
          >
            {/* =========================
                TABS
            ========================= */}

            <div className="col-12">
              <Tabs
                defaultActiveKey="ta"
                items={[
                  {
                    key: "ta",
                    label: "Tamil",
                    children: (
                      <div className="row gy-3">
                        {/* Church Name TAM */}
                        <div className="col-md-6">
                          <label className="form-label">Church Name <span style={{ color: "red" }}>*</span></label>

                          <input
                            type="text"
                            placeholder="Enter Church Name"
                            className={`form-control ${errors.church_name_tn
                              ? "is-invalid"
                              : ""
                              }`}
                            value={
                              formData.church_name.tn
                            }
                            onChange={(e) =>
                              handleLangFieldChange(
                                "church_name",
                                "tn",
                                e.target.value
                              )
                            }
                          />
                        </div>

                        {/* Place ta */}
                        <div className="col-md-6">
                          <label className="form-label">Place<span style={{ color: "red" }}>*</span></label>

                          <input
                            type="text"
                            placeholder="Enter Place"
                            className={`form-control ${errors.place_tn
                              ? "is-invalid"
                              : ""
                              }`}
                            value={formData.place.tn}
                            onChange={(e) =>
                              handleLangFieldChange(
                                "place",
                                "tn",
                                e.target.value
                              )
                            }
                          />
                        </div>

                        {/* Event Title ta */}
                        <div className="col-md-12">
                          <label className="form-label">Event Title<span style={{ color: "red" }}>*</span></label>
                          <input
                            type="text"
                            placeholder="Enter Event Title"
                            className={`form-control ${errors.event_title_tn
                              ? "is-invalid"
                              : ""
                              }`}
                            value={
                              formData.event_title.tn
                            }
                            onChange={(e) =>
                              handleLangFieldChange(
                                "event_title",
                                "tn",
                                e.target.value
                              )
                            }
                          />
                        </div>

                        {/* Details ta */}
                        <div className="col-md-12">
                          <label className="form-label">
                            Details
                          </label>

                          <textarea
                            rows={4}
                            placeholder="Enter Details"
                            className="form-control"
                            value={formData.details.tn}
                            onChange={(e) =>
                              handleLangFieldChange(
                                "details",
                                "tn",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                    ),
                  },

                  {
                    key: "eng",
                    label: "English",
                    children: (
                      <div className="row gy-3">
                        {/* Church Name ENG */}
                        <div className="col-md-6">
                          <label className="form-label">Church Name <span style={{ color: "red" }}>*</span></label>
                          <input
                            type="text"
                            placeholder="Enter Church Name"
                            className={`form-control ${errors.church_name_en
                              ? "is-invalid"
                              : ""
                              }`}
                            value={
                              formData.church_name.en
                            }
                            onChange={(e) =>
                              handleLangFieldChange(
                                "church_name",
                                "en",
                                e.target.value
                              )
                            }
                          />
                        </div>

                        {/* Place ENG */}
                        <div className="col-md-6">
                          <label className="form-label">Place<span style={{ color: "red" }}>*</span></label>
                          <input
                            type="text"
                            placeholder="Enter Place"
                            className={`form-control ${errors.place_en
                              ? "is-invalid"
                              : ""
                              }`}
                            value={formData.place.en}
                            onChange={(e) =>
                              handleLangFieldChange(
                                "place",
                                "en",
                                e.target.value
                              )
                            }
                          />
                        </div>

                        {/* Event Title ENG */}
                        <div className="col-md-12">
                          <label className="form-label">Event Title<span style={{ color: "red" }}>*</span></label>
                          <input
                            type="text"
                            placeholder="Enter Event Title"
                            className={`form-control ${errors.event_title_en
                              ? "is-invalid"
                              : ""
                              }`}
                            value={
                              formData.event_title.en
                            }
                            onChange={(e) =>
                              handleLangFieldChange(
                                "event_title",
                                "en",
                                e.target.value
                              )
                            }
                          />
                        </div>

                        {/* Details ENG */}
                        <div className="col-md-12">
                          <label className="form-label">
                            Details
                          </label>

                          <textarea
                            rows={4}
                            placeholder="Enter Details"
                            className="form-control"
                            value={formData.details.en}
                            onChange={(e) =>
                              handleLangFieldChange(
                                "details",
                                "en",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                    ),
                  },

                  {
                    key: "common",
                    label: "Common",
                    children: (
                      <div className="row gy-3">
                        {/* LATITUDE + LONGITUDE */}
                        <div className="col-md-6">
                          <label className="form-label">
                            Latitude
                          </label>

                          <input
                            type="text"
                            name="latitude"
                            placeholder="e.g. 40.7128"
                            value={formData.latitude}
                            onChange={handleChange}
                            className={`form-control ${errors.latitude ? "is-invalid" : ""
                              }`}
                          />

                          {/* GOOGLE MAP ICON BELOW LATITUDE */}
                          <div className="col-12 mt-2 px-0">
                            <div
                              title="View on Google Maps"
                              onClick={() => {
                                if (formData.latitude && formData.longitude) {
                                  const url = `https://www.google.com/maps?q=${formData.latitude},${formData.longitude}`;
                                  window.open(url, "_blank");
                                } else {
                                  alert(
                                    "Please enter both Latitude and Longitude first."
                                  );
                                }
                              }}
                              style={{
                                cursor: "pointer",
                                display: "inline-flex",
                                padding: "8px",
                                borderRadius: "4px",
                                transition:
                                  "transform 0.2s ease, background-color 0.2s ease",
                              }}
                              onMouseOver={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#f0f0f0";
                                e.currentTarget.style.transform =
                                  "scale(1.1)";
                              }}
                              onMouseOut={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "transparent";
                                e.currentTarget.style.transform =
                                  "scale(1)";
                              }}
                            >
                              <Icon
                                icon="logos:google-maps"
                                width="30"
                                height="30"
                              />
                            </div>
                          </div>
                        </div>

                        {/* LONGITUDE */}
                        <div className="col-md-6">
                          <label className="form-label">
                            Longitude
                          </label>

                          <input
                            type="text"
                            name="longitude"
                            placeholder="e.g. -74.0060"
                            value={formData.longitude}
                            onChange={handleChange}
                            className={`form-control ${errors.longitude ? "is-invalid" : ""
                              }`}
                          />
                        </div>

                        {/* EVENT TYPE */}
                        <div className="col-md-6">
                          <label className="form-label">Event Type<span style={{ color: "red" }}>*</span></label>

                          <Select
                            options={eventOptions}
                            value={
                              eventOptions.find(
                                (option) =>
                                  option.value ===
                                  formData.event_type_id
                              ) || null
                            }
                            onChange={(selected) => {
                              if (!selected) {
                                updateField(
                                  "event_type_id",
                                  ""
                                );

                                updateField(
                                  "event_type_others",
                                  ""
                                );

                                return;
                              }

                              if (
                                selected.value ===
                                "others"
                              ) {
                                updateField(
                                  "event_type_id",
                                  "others"
                                );
                              } else {
                                updateField(
                                  "event_type_id",
                                  selected.value
                                );

                                updateField(
                                  "event_type_others",
                                  ""
                                );
                              }
                            }}
                            styles={customSelectStyles()}
                          />
                        </div>

                        {/* OTHER EVENT */}
                        {formData.event_type_id ===
                          "others" && (
                            <div className="col-md-6">
                              <label className="form-label">
                                Other Event Type
                              </label>

                              <input
                                type="text"
                                className="form-control"
                                value={
                                  formData.event_type_others
                                }
                                onChange={(e) =>
                                  updateField(
                                    "event_type_others",
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          )}

                        {/* START DATE */}
                        <div className="col-md-6">
                          <label className="form-label">Start Date <span style={{ color: "red" }}>*</span></label>

                          <DatePicker
                            showTime={{
                              format: "hh:mm A",
                              use12Hours: true,
                            }}
                            style={{
                              width: "100%",
                              height: "46px",
                            }}
                            format="DD-MM-YYYY hh:mm A"
                            value={
                              formData.start_datetime
                            }
                            onChange={(date) => {
                              updateField(
                                "start_datetime",
                                date
                              );

                              if (
                                !formData.end_datetime ||
                                dayjs(
                                  formData.end_datetime
                                ).isBefore(date)
                              ) {
                                updateField(
                                  "end_datetime",
                                  date.add(1, "hour")
                                );
                              }
                            }}
                          />
                        </div>

                        {/* END DATE */}
                        <div className="col-md-6">
                          <label className="form-label">End Date <span style={{ color: "red" }}>*</span></label>
                          <DatePicker
                            showTime={{
                              format: "hh:mm A",
                              use12Hours: true,
                            }}
                            style={{
                              width: "100%",
                              height: "46px",
                            }}
                            format="DD-MM-YYYY hh:mm A"
                            value={formData.end_datetime}
                            onChange={(date) =>
                              updateField(
                                "end_datetime",
                                date
                              )
                            }
                          />
                        </div>

                        {/* STATUS */}
                        <div className="col-md-6">
                          <label className="form-label">Status<span style={{ color: "red" }}>*</span></label>
                          <Select
                            options={statusOptions}
                            value={
                              statusOptions.find(
                                (option) =>
                                  option.value ===
                                  formData.status
                              ) || null
                            }
                            onChange={(selected) =>
                              updateField(
                                "status",
                                selected.value
                              )
                            }
                            styles={customSelectStyles()}
                          />
                        </div>

                        {/* RECURRING */}
                        <div className="col-md-6">
                          <label className="form-label">Recurring Prayer<span style={{ color: "red" }}>*</span></label>
                          <Select
                            options={recurringOptions}
                            value={
                              recurringOptions.find(
                                (option) =>
                                  option.value ===
                                  formData.is_recurring
                              ) || null
                            }
                            onChange={(selected) =>
                              updateField(
                                "is_recurring",
                                Number(selected.value)
                              )
                            }
                            styles={customSelectStyles()}
                          />
                        </div>

                        {formData.is_recurring === 1 && (
                          <>
                            <div className="col-md-6">
                              <label className="form-label">
                                Recurring Type
                                <span style={{ color: "red" }}>*</span>
                              </label>

                              <Select
                                options={recurrenceTypeOptions}
                                placeholder="Select Recurring Type"
                                value={
                                  recurrenceTypeOptions.find(
                                    (item) =>
                                      item.value === formData.recurring_type
                                  ) || null
                                }
                                onChange={(option) =>
                                  updateField(
                                    "recurring_type",
                                    option?.value || ""
                                  )
                                }
                                styles={customSelectStyles()}
                              />
                            </div>

                            {formData.recurring_type === "monthly" && (
                              <>
                                <div className="col-md-6">
                                  <label className="form-label">
                                    Monthly Week Option
                                    <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <Select
                                    options={monthlyWeekOptions}
                                    placeholder="Select Week Option"
                                    value={
                                      monthlyWeekOptions.find(
                                        (item) =>
                                          item.value === formData.monthly_week
                                      ) || null
                                    }
                                    onChange={(option) =>
                                      updateField(
                                        "monthly_week",
                                        option?.value || ""
                                      )
                                    }
                                    styles={customSelectStyles()}
                                  />
                                </div>

                                <div className="col-md-6">
                                  <label className="form-label">
                                    Weekly Day Option
                                    <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <Select
                                    options={weeklyDayOptions}
                                    placeholder="Select Day Option"
                                    value={
                                      weeklyDayOptions.find(
                                        (item) =>
                                          item.value === formData.weekly_day
                                      ) || null
                                    }
                                    onChange={(option) =>
                                      updateField(
                                        "weekly_day",
                                        option?.value || ""
                                      )
                                    }
                                    styles={customSelectStyles()}
                                  />
                                </div>
                              </>
                            )}

                            {formData.recurring_type === "weekly" && (
                              <div className="col-md-6">
                                <label className="form-label">
                                  Weekly Day Option
                                  <span style={{ color: "red" }}>*</span>
                                </label>

                                <Select
                                  options={weeklyDayOptions}
                                  placeholder="Select Day Option"
                                  value={
                                    weeklyDayOptions.find(
                                      (item) =>
                                        item.value === formData.weekly_day
                                    ) || null
                                  }
                                  onChange={(option) =>
                                    updateField(
                                      "weekly_day",
                                      option?.value || ""
                                    )
                                  }
                                  styles={customSelectStyles()}
                                />
                              </div>
                            )}
                          </>
                        )}

                        {/* View Count */}
                        <div className="col-md-6">
                          <label className="form-label">Views</label>
                          <input
                            type="text"
                            name="views"
                            value={formData.views}
                            onChange={handleChange}
                            className={`form-control ${errors.latitude ? "is-invalid" : ""}`}
                          />
                        </div>

                        {/* Share Count */}
                        <div className="col-md-6">
                          <label className="form-label">Share</label>
                          <input
                            type="text"
                            name="share"
                            value={formData.share}
                            onChange={handleChange}
                            className={`form-control ${errors.longitude ? "is-invalid" : ""}`}
                          />
                        </div>

                        {/* IMAGE */}
                        <div className="col-md-6">
                          <label className="form-label">
                            Image
                          </label>

                          <input
                            type="file"
                            name="church_photo"
                            className="form-control"
                            onChange={handleChange}
                          />

                          {(formData.previewImage ||
                            formData.church_photo) && (
                              <div className="mt-3">
                                <ImagePreviewModal
                                  src={
                                    formData.previewImage
                                  }
                                  alt="Preview"
                                  thumbWidth={80}
                                  thumbHeight={80}
                                />
                              </div>
                            )}
                        </div>
                      </div>
                    ),
                  },
                ]}
              />
            </div>

            {/* SUBMIT */}
            <div className="col-12 d-flex justify-content-end mt-3 gap-2">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onCancel}
              >
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-primary"
              >
                {isEdit
                  ? "Update Event"
                  : "Create Event"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}